import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app/shared/api/api.service';
import * as validate from '../state';
import { Observable } from 'rxjs';
import { Identity } from '@app/auth/models';

@Injectable()
export class ValidateService {
  constructor(private http: HttpClient, private api: API) {}

  public validate$(body: validate.ValidateIdentity): Observable<Identity> {
    return this.http.post<Identity>(this.api.VALIDATE(), body);
  }

  public validateLink$(body: Pick<validate.ValidateIdentity, 'identityValidationToken' | 'email'>): Observable<any> {
    return this.http.post<Identity>(this.api.VALIDATE_LINK(), body);
  }
}
